/**
 * Specific selectors
 */
const selectAccountsList = (state) => state.getIn(['workspaceAccounts', 'accounts']);
const selectTeamList = (state) => state.getIn(['workspaceTeams', 'teams']);
const selectWorkspacesList = (state) => state.getIn(['workspaceWorkspaces', 'workspaces']);
const selectWorkspacesLoadingState = (state) => state.getIn(['workspaceWorkspaces', 'loading']);
const selectTeamAccounts = (state, teamId) => {
  const team = state.getIn(['workspaceTeams', 'team', teamId]);
  return team && team.accounts;
};
const selectWorkspaceCollaborators = (state, workspaceId) => {
  const workspace = state.getIn(['workspaceWorkspaces', 'workspace', workspaceId]);

  return workspace && workspace.collaborators;
};
const selectWorkspace = (state) => state.getIn(['workspaceWorkspaces', 'selectedWorkspace']);

const normalizeAccessRequestItem = (item) => {
  if (!item) return item;
  if (item.accessRequest) {
    return {
      ...item.accessRequest,
      email: item.profile?.primaryEmail ?? item.profile?.email ?? item.accessRequest.email,
      familyName: item.profile?.familyName || 'familyName',
      givenName: item.profile?.givenName || 'givenName',
    };
  }
  return item;
};

const selectRequestAccessRequests = (state) => {
  const review = state.getIn(['workspaceRequestAccess', 'review']);
  const complete = state.getIn(['workspaceRequestAccess', 'complete']);
  const deny = state.getIn(['workspaceRequestAccess', 'deny']);
  const toList = (val) => (val && typeof val.toJS === 'function' ? val.toJS() : val) || [];
  const withStatus = (list, status) => (Array.isArray(list) ? list : []).map((r) => ({ ...normalizeAccessRequestItem(r), status }));
  return [
    ...withStatus(toList(review), 'REVIEW'),
    ...withStatus(toList(complete), 'COMPLETE'),
    ...withStatus(toList(deny), 'DENY'),
  ];
};

const selectRequestAccessLoaded = (state) => {
  const loaded = state.getIn(['workspaceRequestAccess', 'loaded']);
  const get = (key) => (loaded && loaded.get ? loaded.get(key) : loaded?.[key]) === true;
  return {
    review: get('review'),
    complete: get('complete'),
    deny: get('deny'),
  };
};

/** True when we have received COMPLETE and DENY list responses (so "no completed requests" is accurate). */
const selectCompleteTabLoaded = (state) => {
  const l = selectRequestAccessLoaded(state);
  return l.complete && l.deny;
};

/** True when we have received REVIEW list response. */
const selectToDoTabLoaded = (state) => selectRequestAccessLoaded(state).review;

export {
  selectAccountsList,
  selectTeamList,
  selectWorkspacesList,
  selectWorkspacesLoadingState,
  selectTeamAccounts,
  selectWorkspaceCollaborators,
  selectWorkspace,
  selectRequestAccessRequests,
  selectRequestAccessLoaded,
  selectCompleteTabLoaded,
  selectToDoTabLoaded,
};
